import { render, staticRenderFns } from "./CustomerCommunicationAggregatedActivity.vue?vue&type=template&id=b01caea6&scoped=true&"
import script from "./CustomerCommunicationAggregatedActivity.vue?vue&type=script&lang=js&"
export * from "./CustomerCommunicationAggregatedActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01caea6",
  null
  
)

export default component.exports